import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModalComponent } from '../../../../../shared/components/dialogs/modal/modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DashboardDto } from '../../../../../../api-main';
import { EmuInputComponent } from '../../../../../shared/components/inputs/emu-input/emu-input.component';

@Component({
  selector: 'app-dashboard-template-modal',
  imports: [
    MatDialogContent,
    MatFormFieldModule,
    MatInputModule,
    ModalComponent,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    EmuInputComponent,
  ],
  templateUrl: './dashboard-template-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard-template-modal.component.scss',
})
export class DashboardTemplateModalComponent {
  private dialogRef = inject<MatDialogRef<DashboardTemplateModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  dashboard: DashboardDto;

  private blockInput = false;

  constructor() {
    const data = this.data;

    this.dashboard = data;
  }

  onSave() {
    if (this.blockInput) return;
    this.blockInput = true;
    this.dialogRef.close(this.dashboard);
  }

  isValid() {
    const name = this.dashboard.name;
    return name && name != '';
  }
}
